import * as React from 'react';
import { SVGProps } from 'react';

const IconMailSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 6a2 2 0 0 0-2 2l10.042 5.478a2 2 0 0 0 1.916 0L25 8a2 2 0 0 0-2-2H5Z" />
    <path d="M13.042 16.478 3 11v9a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-9l-10.042 5.478a2 2 0 0 1-1.916 0Z" />
  </svg>
);
export default IconMailSizeL;
